@import '../../../assets/styles/theme.scss';

.btn {
  flex-shrink: 0;
  border-radius: 4px;
  padding: 7px 12px;
  font-size: 15px;
  font-weight: 300;
  display: flex;
  flex: 0;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.1);
  color: $gray-900;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid transparent;
  outline: none;
  text-decoration: none !important;
  &:focus {
    outline: none;
  }
  &.mini {
    padding: 4px 6px;
    font-size: 12px;
  }
  &:disabled {
    pointer-events: none;
  }
  transition: all 0.2s linear;
  &:hover {
    background-color: rgba(0, 0, 0, 0.12);
    border: 1px solid rgba(0, 0, 0, 0.12);
  }
  &:active {
    transform: scale(0.98);
  }
}
.stretch {
  align-self: stretch;
}
.raised {
  box-shadow: 0 0 4px 0 $gray-900;
}

.primary {
  background-color: $orange-500;
  border: 1px solid $orange-500;
  color: white;
  &:hover {
    background-color: $orange-600;
  }
}
.secondary {
  background-color: transparent;
  border: 1px solid transparent;
  color: $gray-900;
  &:hover {
    transform: none;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: rgba(0, 0, 0, 0.1);
  }
}
.submit {
  background-color: $blue-500;
  border: 1px solid $blue-500;
  color: white;
  &:hover {
    background-color: $blue-600;
  }
  &:disabled {
    background-color: $blue-100 !important;
  }
}
